// Page names
export const SEARCH_PAGE = "SEARCH_PAGE";
export const CATEGORY_PAGE = "CATEGORY_PAGE";
export const BRAND_ERROR = "BRAND_ERROR";
export const BRANDS_PAGE = "BRANDS_PAGE";
export const PAGE_NOT_FOUND = "PAGE_NOT_FOUND";
export const BRAND_UNAVAILABLE = "BRAND_UNAVAILABLE";
export const UNKNOWN_PAGE = "UNKNOWN_PAGE";

//EMF-787 Search Results Pre-Filtered by Gender
export const UNISEX_FLOOR = "2001";
export const FACE_AND_BODY_CID = "2373";

export const hasFloorFilters = refineParam =>
  refineParam && /floor:\d+/.test(refineParam);

export const PAGES = [
  SEARCH_PAGE,
  CATEGORY_PAGE,
  BRANDS_PAGE,
  BRAND_ERROR,
  PAGE_NOT_FOUND,
  BRAND_UNAVAILABLE,
  UNKNOWN_PAGE
];
